import { USER_COVER } from "@/data/myAlbum";

const u = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?q=80&w=${w}&auto=format&fit=crop`;

export const HERO_IMAGE = USER_COVER;
export const PORTRAIT_IMAGE = u("1603574670812-d24560880210", 1200);
export const RETOUCH_IMAGE = u("1564013799919-ab600027ffc6", 1800);

export const CATEGORIES = [
  "All",
  "My Photos",
];

export const ALBUMS = [];

export const TESTIMONIALS = [
  {
    quote:
      "The drone shots sell the location before buyers even book a showing. My listings have never looked better online.",
    name: "Listing Agent",
    role: "Astoria, OR",
  },
  {
    quote:
      "Fast, friendly, and the photos are bright even on grey coastal days. Delivered before I finished the paperwork.",
    name: "Broker",
    role: "Cannon Beach, OR",
  },
  {
    quote:
      "Sold our home ourselves and the photos made all the difference — people thought we hired a big-city agency.",
    name: "For-Sale-By-Owner",
    role: "Seaside, OR",
  },
];

